(function () {
    angular
        .module('tradersyard')
        .factory('WebSocket', webSocketFactory)
        .factory('$socket', [
            'WebSocket',
            function ($socket) {
                return $socket;
            },
        ]);

    webSocketFactory.$inject = ['$rootScope', '$q'];

    function webSocketFactory($rootScope, $q) {
        /**
         * Socket.IO Client
         * @type {SocketIOClient.Socket}
         */
        const socket = io({ path: '/broadcast/' });

        /**
         * This keeps cache of the connected rooms?
         * @type {{}}
         */
        const joinCache = {};

        /**
         * Connection status of the WS as an observable
         */
        const isConnected$ = new Rx.BehaviorSubject(undefined);

        socket.on('connect', () => {
            console.log('Websocket connected');
            isConnected$.onNext(true);
        });

        socket.on('disconnect', () => {
            console.log('Websocket disconnected');
            isConnected$.onNext(false);
        });

        return {
            on: onSocketEvent,
            emit: emitSocketEvent,
            getSocketId: getSocketId,
            onEventPromise: onEventPromise,
            onceConnectPromise: onceConnectPromise,
            onReconnect: onReconnect,
            isConnected$,
        };

        /**
         * Setup a callback to listen for reconnect
         * @param callback
         */
        function onReconnect(callback) {
            socket.io.on('reconnect', callback);
        }

        /**
         * You can use this function to wait for a socket connection.
         * Promise is resolved only once and only on success - there is no rejection implemented.
         * The resolved promise value is Socket ID.
         *
         * @returns {ng.IPromise<string>}
         */
        function onceConnectPromise() {
            /**
             * @type {angular.IDeferred<string>}
             */
            var defer = $q.defer();

            socket.once('connect', function () {
                defer.resolve(socket.id);
            });

            return defer.promise;
        }

        /**
         * Wraps {@see SocketIOClient.Emitter.on} in order to integrate it with AngularJS.
         * It applies $rootScope.$apply() to inform AngularJS of changes, so that updates are performed
         *
         * @param eventName
         * @param callback
         */
        function onSocketEvent(eventName, callback) {
            socket.on(eventName, function (eventData) {
                callback(eventData, eventData.guid);
                $rootScope.$apply();
            });
        }

        /**
         * Emit socket event. Special behavior is applied for `join:` events.
         * @param event
         * @param ...args
         * @returns {SocketIOClient.Socket}
         */
        function emitSocketEvent(event, ...args) {
            if (!event.startsWith('join:chat') && event.startsWith('join:')) {
                return emitSocketJoinEvent(event, ...args);
            }

            return socket.emit.apply(socket, [event, ...args]);
        }

        /**
         * Emit socket event for `join:` events
         * @param event
         * @param ...args
         * @returns {SocketIOClient.Socket}
         */
        function emitSocketJoinEvent(event, ...args) {
            const [data, ...rest] = args;
            var filteredData = filterJoinData(event, data);

            if (filteredData && filteredData.length > 0) {
                return socket.emit.apply(socket, [event, filteredData, ...rest]);
            }

            return socket;
        }

        /**
         * @return {string}
         */
        function getSocketId() {
            return socket.id;
        }

        /**
         * Returns a {@link ng.IPromise} that will resolve when socket event is received.
         * If predicate is passed, promise will resolve only when predicate returns true value.
         *
         * You can use this method when you want to react to some event only once.
         *
         * TODO: Think about introducing RxJS for more fluent event handling
         *
         * @param {string} eventName
         * @param {Function} [predicate]
         * @returns {ng.IPromise}
         */
        function onEventPromise(eventName, predicate) {
            console.log('Waiting for event promise: %s ...', eventName);

            var eventDefer = $q.defer();

            var resolvePromiseOnEvent = function (eventData) {
                console.log('Event promise received: %s', eventName, eventData);

                if (!predicate || true === predicate(eventData)) {
                    return eventDefer.resolve(eventData);
                }

                console.log('Event predicate not matched. Waiting for another event ...');
            };

            socket.on(eventName, resolvePromiseOnEvent);

            // Turn off listener when promise resolves
            eventDefer.promise.finally(function () {
                console.log('Event promise fulfilled: %s. Listener off. Goodbye!', eventName);
                socket.off(eventName, resolvePromiseOnEvent);
            });

            return eventDefer.promise;
        }

        function filterJoinData(event, data) {
            if (!joinCache[event]) {
                joinCache[event] = [];
            }

            return data
                ? data.filter(function (roomId) {
                      if (joinCache[event].indexOf(roomId) < 0) {
                          // not exists

                          joinCache[event].push(roomId);

                          return true;
                      } else {
                          return false;
                      }
                  })
                : undefined;
        }
    }
})();
